import React from "react";
import { Utensils, ShoppingBag, Bike, ArrowUpRight, MessageCircle } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { whatsappUrl, serviceMessage } from "../../lib/whatsapp";

const ICONS = [Utensils, ShoppingBag, Bike];

export default function Servicios() {
  const { t } = useLanguage();
  const items = t.services.items;

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 border-t border-[#E5E0D8] bg-[#F2EDE3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl mb-14">
          <div className="eyebrow mb-4">{t.services.eyebrow}</div>
          <h2
            data-testid="services-title"
            className="font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-[#1A1A1A]"
          >
            {t.services.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-[#E5E0D8] border border-[#E5E0D8] bg-white">
          {items.map((s, idx) => {
            const Icon = ICONS[idx];
            const waMsg = serviceMessage(t, s.title);
            return (
              <a
                key={idx}
                href={whatsappUrl(waMsg)}
                target="_blank"
                rel="noreferrer"
                data-testid={`service-card-${idx}`}
                className="group p-8 md:p-10 lg:p-12 flex flex-col gap-6 hover:bg-[#F9F6F0] transition-colors text-left w-full"
              >
                <div className="flex items-center justify-between">
                  <Icon className="h-8 w-8 text-[#8B1E0F]" strokeWidth={1.4} />
                  <ArrowUpRight className="h-5 w-5 text-[#1A1A1A] opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all" />
                </div>
                <div>
                  <h3 className="font-serif-display text-2xl md:text-3xl text-[#1A1A1A] mb-3">
                    {s.title}
                  </h3>
                  <p className="text-[#5C5C5C] leading-relaxed text-sm md:text-base">
                    {s.body}
                  </p>
                </div>
                <div className="mt-auto pt-4 border-t border-[#E5E0D8] flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-[#25D366]">
                  <MessageCircle className="h-3.5 w-3.5" />
                  {s.cta} →
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
